import { Button, styled } from '@mui/material';

export const ButtonSubmitStyle = styled(Button)`
  &.Mui-disabled {
    background: none !important;
  }
`;
